import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import ReactGA from "react-ga4";
import { Container, Image, Card } from 'react-bootstrap'
import './app.scss';
import rose from './images/rose.svg';
import Main from './Main';
import Epilogue from './Epilogue';

function App() {

  // new: 313435795
  // old: UA-168892917-2
  useEffect(() => {
    ReactGA.initialize('G-SRV34W3X3L');
    if (process.env.NODE_ENV === 'production') {
      //ReactGA.pageview(window.location.pathname);
      ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }
  }, []);

  const gaTrack = (category, action) => {
    if (process.env.NODE_ENV === 'production') {
        ReactGA.event({ category, action })
    }
  }

  return (
    <Container className="book-container">

        <Router>
          <Switch>
            <Route exact path="/epilogue">
              <Epilogue />
            </Route>
            <Route path="/">
              <Main />
            </Route>
          </Switch>
        </Router>


      <footer className="text-center book-footer">
        <div>
          <a href="https://www.IntentionallyCatholic.com"
            target="_blank" rel="noopener noreferrer"
            onClick={() => gaTrack('Resources', 'IntentionallyCatholicLink')}
            style={{ fontStyle: "italic", fontWeight: "400" }}>
            Intentionally Catholic .com
          </a>
        </div>
        <div className="rosie">
          <a href="https://www.RosieBeagan.com"
            target="_blank" rel="noopener noreferrer"
            onClick={() => gaTrack('Resources', 'RosieLink')}
            style={{ fontStyle: "italic", fontWeight: "500" }}>
            <Image src={rose} 
            className="img-fluid rounded" 
            title="Rose Elizabeth Foundation" 
            width="40px"
          />
            Rosie
          </a>
        </div>
      </footer>

    </Container>
  );
}

export default App;
